<template>
    <form @submit.prevent="submit()">
        <div :class="{'has-error': errors.name}" class="form-group col-sm-6">
            <label for="id_pages">Trámite:</label>
            <input name="id_pages" type="number" id="id_pages" class="form-control" v-model="data.id_pages" v-on:change="changeTitle" />
            <div class="help-block" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>
        <div :class="{'has-error': errors.name}" class="form-group col-sm-6">
            <label for="name">Nombre:</label> 
            <input maxlength="256" name="name" type="text" id="name" class="form-control" :value="data.name" />
            <div class="help-block" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>
        <div class="form-group col-sm-6">
            <label for="agendamiento">Activar acceso en la ficha:</label> 
            <label class="checkbox-inline">
                <input name="agendamiento" type="checkbox" value="1" id="agendamiento"  v-model="data.agendamiento" />
            </label>
        </div>
        <div class="form-group col-sm-12">
            <input type="submit" value="Guardar" class="btn btn-primary"> 
            <a href="/backend/agendamiento" class="btn btn-default">Cancelar</a>
        </div>
    </form>
</template>

<style lang="scss" scoped>
</style>

<script>
import Vue from 'vue';

export default {
    name: "FormAddTramiteSucursalVirtual",
    data() {
        return {
            errors: {},
            data: {
                "id_pages": "",
                "name": "",
                "agendamiento": true
            },
        }
    },
    mounted() {
    },
    created() {
    },
    methods: {
        changeTitle: function() {
            axios.get('/backend/tramites-sucursal-virtual/getdata/' + this.data.id_pages)
                .then((response) => {
                    console.log(response.data);
                    if (response.status == 200) {
                        if (response.data.page) {
                            this.data.name = response.data.page;
                        } else {
                            this.data.name = "";
                            alert("Trámite no existe.");
                        }
                    } else {
                        alert("Trámite no existe.");
                    }
                });
        },
        submit: function() {
            this.errors = {};
            // si campo tramite es vacio
            if(typeof(this.data.id_pages) == undefined || this.data.id_pages == '' || this.data.id_pages == null) {
                this.errors.id_pages = "El campo Tramite es requerido";
            } else {
                this.errors.id_pages = false;
            }

            // si campo nombre es vacío
            if(typeof(this.data.name) == undefined || this.data.name == '' || this.data.name == null) {
                this.errors.name = "El campo Nombre es requerido";
            } else {
                this.errors.name = false;
            }

            if(typeof(this.data.agendamiento) == undefined || this.data.agendamiento == '' || this.data.agendamiento == null) {
                this.data.agendamiento = 0;
            }

            if (!this.errors.name && !this.errors.id_pages) {
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
                let params = new FormData();
                params.append('id_pages', this.data.id_pages);
                params.append('name', this.data.name);
                params.append('agendamiento', this.data.agendamiento);
                axios.post('/backend/agendamiento', params, config)
                    .then((response) => {
                        const { respuesta } = response.data;
                        if (response.data.codigoRetorno == 200) {
                            window.location.replace(response.data.redirect);
                            // console.log('codigo de retorno satisfactorio')
                        } else {
                            alert(`Hubo un error al intentar guardar el trámite. ${respuesta[0]}`);
                        }
                    }).catch(function(error){ 
                        console.log(error);
                });
            }
        }
    },
}
</script>
